<template>
  <DataTable/>
</template>

<script>
  import HelloWorld from '../components/HelloWorld'
  import DataTable from '../components/DataTable.vue'

  export default {
    title: 'View Mandates',
    components: {
      DataTable
    }
  }
</script>
